import axios from 'axios'
import { apiUrl } from '../../index'

const get = (url: string, params?: any) =>
  axios.get(apiUrl + url, { params, withCredentials: true }).then((r) => r.data)

const post = (url: string, body?: any) =>
  axios.post(apiUrl + url, body, { withCredentials: true }).then((r) => r.data)

const put = (url: string, body?: any) =>
  axios.put(apiUrl + url, body, { withCredentials: true }).then((r) => r.data)

const del = (url: string) =>
  axios.delete(apiUrl + url, { withCredentials: true }).then((r) => r.data)

export function listParceiros(params: {
  nome?: string
  uf?: string
  createdAtFrom?: string
  createdAtTo?: string
  matriculasMin?: number
  matriculasMax?: number
  cursoId?: number
  parceiroPaiId?: number
  somenteForaDoPadrao?: boolean
  incluirInativos?: boolean
  sortBy?: string
  sortDir?: string
  page?: number
  pageSize?: number
}) {
  return get('/admin/parceiros', params)
}

export interface ParceiroPaiOption {
  id: number
  nome: string
}

// Only parceiros that have captadores under them — the options of the list's "Parceiro pai" filter.
export function listParceirosPais(): Promise<ParceiroPaiOption[]> {
  return get('/admin/parceiros/pais')
}

export function setParceiroAtivo(id: number, ativo: boolean) {
  return put(`/admin/parceiros/${id}/ativo`, { ativo })
}

export interface CursoParaPreco {
  id: number
  nomeReduzido: string
  categorias: string
  ofertadoDesde: string | null
}

// Only courses currently offered (ofertadoDesde set and not in the future) — the ones that can have
// a configured price. Feeds the course selector that drives the list's price column.
export async function listCursosAtivos(): Promise<CursoParaPreco[]> {
  const cursos: CursoParaPreco[] = await get('/cursos/all')
  const agora = Date.now()
  return cursos.filter(
    (curso) => curso.ofertadoDesde != null && new Date(curso.ofertadoDesde).getTime() <= agora
  )
}

export function createParceiro(dto: {
  cpfCnpj: string
  nome: string
  telefone?: string
  uf?: string
}) {
  return post('/admin/parceiros', dto)
}

export function getParceiro(id: number) {
  return get(`/admin/parceiros/${id}`)
}

export function updateParceiro(id: number, dto: { nome?: string; telefone?: string; uf?: string }) {
  return put(`/admin/parceiros/${id}`, dto)
}

export function listUsuariosParceiro(parceiroId: number) {
  return get(`/admin/parceiros/${parceiroId}/usuarios`)
}

export function createUsuarioParceiro(
  parceiroId: number,
  dto: { nome: string; email: string; cpf: string; role: string }
) {
  return post(`/admin/parceiros/${parceiroId}/usuarios`, dto)
}

export function deleteUsuarioParceiro(parceiroId: number, usuarioId: number) {
  return del(`/admin/parceiros/${parceiroId}/usuarios/${usuarioId}`)
}

export function createPasswordToken(parceiroId: number, usuarioId: number) {
  return post(`/admin/parceiros/${parceiroId}/usuarios/${usuarioId}/password-token`)
}

export function getVendas(parceiroId: number, params: { granularidade?: string }) {
  return get(`/admin/parceiros/${parceiroId}/vendas`, params)
}

export interface PrecoParceiroItem {
  cursoId: number
  cursoNome: string
  categoria: string
  configuradorRecebe: number | null
  precoFinal: number | null
  faltante: boolean
}

export interface PrecosParceiro {
  mode: 'root' | 'node'
  itens: PrecoParceiroItem[]
}

export function getPrecosParceiro(parceiroId: number): Promise<PrecosParceiro> {
  return get(`/admin/parceiros/${parceiroId}/precos`)
}


export function fetchCnpjFromBrasilApi(cnpj: string) {
  return axios
    .get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`, { withCredentials: false })
    .then((r) => r.data)
}
